import { h } from 'preact';
import CompanyInfo from './company-info';
import Container from '../container';
import Description from './description';
import { FinanceSpinner } from '../glyphs';
import style from './style';
import cx from 'classnames';
import { Text } from 'preact-i18n';
import wire from 'wiretie';
import connect from '@cube/store-connect';
import { config } from '@os/finance-model';
import dlv from 'dlv';

export const INTL_NS = 'company-profile';

export function ProfilePhone({ symbol, profileData, locale })  {
	let rows = profileData && profileData.rows && profileData.rows[0];

	if (!rows) {
		return (
			<FinanceSpinner />
		);
	}

	return (
		<div class={cx(style.profile, style.phone)}>
			<Container
				parent
				title={<Text id={`${INTL_NS}.companyProfile`} />}
				class={style.phoneHeader}
				transform="uppercase"
			>
				<CompanyInfo
					data={profileData}
					symbol={symbol}
					class={style.phone}
				/>
				<Description
					data={profileData}
					hide={locale && dlv(config, 'limitedLocales', []).indexOf(locale) >=0}
				/>
			</Container>
		</div>
	);
}

let ConnectedProfilePhone = connect(({ locale }) => ({ locale }))(ProfilePhone);

export default wire('financeModel', ({ symbol }) => ({
	profileData: ['getProfile', symbol]
}))(ConnectedProfilePhone);
